import { Flex, Typography, theme } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { CardComponent } from "../../../../components/Card/CardComponent.tsx"
import Icon from "../../../../Icon/index.tsx"
import { STORY_BIG_PICTURE_CATEGORIES } from "../../content/product-story.ts"

const { Title, Text } = Typography

export const BigPictureDiagram = () => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <Flex vertical gap={16}>
      <Flex
        vertical
        align="center"
        gap={2}
        className="rounded-xl py-5"
        style={{ background: token.colorPrimaryBg }}
      >
        <Text
          className="text-xs font-semibold uppercase tracking-widest"
          style={{ color: token.colorPrimary }}
        >
          {t("guide.story.bigPicture.osLabel")}
        </Text>
        <Title level={3} className="!mb-0">
          EZBuild
        </Title>
      </Flex>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {STORY_BIG_PICTURE_CATEGORIES.map((category) => {
          const items = t(category.itemsKey, {
            returnObjects: true
          }) as string[]
          return (
            <CardComponent key={category.id} className="h-full">
              <Flex vertical gap={10}>
                <Flex align="center" gap={8}>
                  <Flex
                    align="center"
                    justify="center"
                    className="size-8 shrink-0 rounded-full"
                    style={{
                      background: token.colorPrimaryBg,
                      color: token.colorPrimary
                    }}
                  >
                    <Icon type={category.icon} />
                  </Flex>
                  <Text strong>{t(category.titleKey)}</Text>
                </Flex>
                <Flex vertical gap={3}>
                  {items.map((item) => (
                    <Text key={item} type="secondary" className="text-sm">
                      {item}
                    </Text>
                  ))}
                </Flex>
              </Flex>
            </CardComponent>
          )
        })}
      </div>
    </Flex>
  )
}
